module.exports = __webpack_public_path__ + "media/images/riders/IRINA_KALENTYEVA-0fbf4a0c2043607ebfa089f0fd59cccb.png";